import "mapbox-gl/dist/mapbox-gl.css";

import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { supported } from "mapbox-gl";
import ReactMapboxGL from "react-mapbox-gl";

import { mapClickHandler } from "../reducers/ownApp/thunkActions";
import { setIsZooming } from "../reducers/map";
import {
  setZoomValue,
  setReceivedUserInput,
  calculateZoomLevel,
} from "../reducers/map/thunkActions";
import { zoomSelector } from "../reducers/map/selectors";

const accessToken = process.env.REACT_APP_MAPBOX_API_KEY;

const styles = {
  position: "relative",
  height: "100%",
  width: "100%",
};

const Map = ReactMapboxGL({
  accessToken,
  attributionControl: false,
  logoPosition: "top-right",
});

const Mapbox = memo(({ children, handleOnLoad, application, ...rest }) => {
  const dispatch = useDispatch();
  const zoom = useSelector(zoomSelector);

  const mapStyle = {
    style: "mapbox://styles/mapbox/dark-v10?optimize=true",
    attributionControl: false,
  };

  if (supported()) {
    return (
      <Map
        onStyleLoad={handleOnLoad}
        {...mapStyle}
        containerStyle={styles}
        zoom={zoom}
        onZoomStart={() => dispatch(setIsZooming(true))}
        onZoomEnd={() => {
          dispatch(setIsZooming(false));
        }}
        onZoom={(map) => {
          dispatch(setZoomValue([map.getZoom()]));
          dispatch(calculateZoomLevel());
        }}
        {...rest}
        onClick={(map, { point, lngLat }) => {
          dispatch(setReceivedUserInput(true));
          dispatch(mapClickHandler({ map, point, lngLat, application }));
        }}
        onDragStart={() => dispatch(setReceivedUserInput(true))}
      >
        {children}
      </Map>
    );
  } else {
    return <p>Your browser does not support Mapbox</p>;
  }
});

export default Mapbox;
